import { EPath } from "constants/path";
import { useAuth } from "contexts/AuthContext";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import HomeLayout from "routes/layouts/HomeLayout";

function NotFound() {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  useEffect(() => {
    const currentPath = window.location.pathname;
    if (currentPath === "/") {
      navigate(EPath.PRACTICE_MANAGEMENT);
    }
    if (!loading && !user) {
      navigate(EPath.LOGIN);
    }
  }, [navigate, loading, user]);
  return loading ? (
    <div className="flex flex-col items-center justify-center h-screen text-center">
      <h1 className="text-2xl font-bold text-blue-600">Loading...</h1>
    </div>
  ) : (
    <HomeLayout>
      <div className="flex flex-col items-center justify-center h-screen text-center">
        <h1 className="text-2xl font-bold text-blue-600">Not Found</h1>
        <p className="text-lg text-gray-600">
          The page you are looking for does not exist.
        </p>
      </div>
    </HomeLayout>
  );
}

export default NotFound;
